/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_Background_LabelInputs */



/**
* | output |
* | --- |
* | "Background (music and effects)" |
*
* @param {Audio_Stems_Background_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_background_label = /** @type {((inputs?: Audio_Stems_Background_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Background_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fond (musique et effets)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hintergrund (Musik und Effekte)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottofondo (musica ed effetti)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фон (музыка и эффекты)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fondo (música y efectos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("背景（音乐和音效）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("背景（音楽と効果音）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैकग्राउंड (संगीत और इफ़ेक्ट)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fundo (música e efeitos)")
	return /** @type {LocalizedString} */ ("Background (music and effects)")
});